package data.db.delight

import DatabaseDriverFactory
import com.kinoshazam.shared.data.db.sqldelight.KinoshkaDb
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock

class AppDatabase(private val databaseDriverFactory: DatabaseDriverFactory) {

    private val mutex = Mutex()
    private var dbQuery: KinoshkaDbQueries? = null

    suspend fun queries(): KinoshkaDbQueries? = mutex.withLock {
        dbQuery?.let { return it }
        val driver = databaseDriverFactory.createDriver() ?: return null
        val queries = KinoshkaDb(driver).kinoshkaDbQueries
        dbQuery = queries
        queries
    }
}
